/*
  Menu Trigger - SP
================================================================= */
window.addEventListener('DOMContentLoaded', () => {

  const trigger = document.querySelector('.menu-trigger');
  const globalNav = document.querySelector('.global-nav');

  if (trigger && globalNav) {
    trigger.addEventListener('click', () => {
      if (window.innerWidth > 835) return;

      trigger.classList.toggle('is-toggled');
      globalNav.classList.toggle('is-opened');
    });
  }

  /*
    IntersectionObserver - orange-line text animation
  ================================================================= */
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      entry.target.classList.toggle('is-visible', entry.isIntersecting);
    });
  }, {
    rootMargin: '0px 0px -10%'
  });

  document.querySelectorAll('[data-io]').forEach(el => observer.observe(el));

});
